import { render, staticRenderFns } from "./MigrationBanner.vue?vue&type=template&id=33470cb9&"
import script from "./MigrationBanner.vue?vue&type=script&lang=ts&"
export * from "./MigrationBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports